module.exports = "https://static.im-cdn.com/mjc/storefront/Accent/static/media/whiteClose.fd7383f5.svg";